import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import rootReducer from './reduces'
const initialState = {
    tabs: [{path: '/', name: '首页'}]
}
const configureStore = (preloadedState: any) => {
    return createStore(
        rootReducer, 
        preloadedState, 
        applyMiddleware(thunkMiddleware)
    )
}
const store = configureStore(initialState)
export default store
